// ═══════════════════════════════════════════════════════════════════
//  modules/erp/PlayerGradesTab.js
//  PlayerGradesTab
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { Badge } from "../../composants/Badge";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";

export function PlayerGradesTab({ uuid, groups, primaryGroup, token, onRefresh }) {
  const [newGrade, setNewGrade] = useState("");
  const [saving, setSaving] = useState(false);

  const handleGradeChange = async () => {
    if (!newGrade.trim()) return;
    setSaving(true);
    await fetch(`${API_BASE}/api/players/${uuid}/grade`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ grade: newGrade }),
    });
    setSaving(false);
    setNewGrade("");
    onRefresh();
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: 16 }}>
        <div style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 600, marginBottom: 8 }}>GRADE PRINCIPAL</div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Badge text={primaryGroup} bg={THEME.accentDim} color={THEME.accent} />
          <span style={{ color: THEME.textMuted, fontSize: 12 }}>via LuckPerms</span>
        </div>
      </div>

      <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: 16 }}>
        <div style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 600, marginBottom: 10 }}>TOUS LES GROUPES</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {groups.length === 0 && <div style={{ color: THEME.textDim, fontSize: 12 }}>Aucun groupe assigné</div>}
          {groups.map((g, i) => {
            const groupName = g.permission.replace("group.", "");
            const isExpired = g.expiry > 0 && g.expiry * 1000 < Date.now();
            return (
              <div key={i} style={{ background: isExpired ? THEME.redDim : THEME.surface, border: `1px solid ${isExpired ? THEME.red : THEME.border}`, borderRadius: 6, padding: "6px 12px" }}>
                <div style={{ color: isExpired ? THEME.red : THEME.text, fontSize: 12, fontWeight: 600 }}>{groupName}</div>
                {g.expiry > 0 && (
                  <div style={{ color: THEME.textDim, fontSize: 10 }}>
                    {isExpired ? "⚠️ Expiré" : `Expire le ${new Date(g.expiry * 1000).toLocaleDateString("fr")}`}
                  </div>
                )}
                {g.server && g.server !== "global" && <div style={{ color: THEME.textDim, fontSize: 10 }}>Serveur : {g.server}</div>}
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: 16 }}>
        <div style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 600, marginBottom: 10 }}>MODIFIER LE GRADE PRINCIPAL</div>
        <div style={{ display: "flex", gap: 8 }}>
          <input value={newGrade} onChange={(e) => setNewGrade(e.target.value)} placeholder="ex: vip, staff, admin..."
            style={{ flex: 1, background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 6, padding: "8px 12px", color: THEME.text, fontSize: 13, outline: "none" }} />
          <button onClick={handleGradeChange} disabled={saving || !newGrade.trim()}
            style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 6, padding: "8px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700, opacity: saving ? 0.6 : 1 }}>
            {saving ? "..." : "Appliquer"}
          </button>
        </div>
        <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 6 }}>⚠️ Utilise la commande lp user parent set — le joueur doit être connecté ou le changement sera appliqué hors ligne.</div>
      </div>
    </div>
  );
}
